import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteView = async (database: string, viewName: string) => {
  const result = await systemEngineEnvironment.execute(
    `DROP VIEW IF EXISTS "${viewName}"`,
    { database }
  );
  return result;
};
